import { action, computed, observable } from 'mobx';
import { useRootStore } from './index';
import { NewTextAsset } from 'routes/ArticleGroup/CreativeTemplates/CreativeTemplatesBuilder/types';
import { CreativeTemplatesEntities } from '../routes/ArticleGroup/CreativeTemplates/./CreativeTemplatesBuilder/constants';
import { PostMaloneScoreSourceTypeEnum } from '../api';

const { PostTexts, Headlines, Descriptions } = CreativeTemplatesEntities;

export class TextAssetsBuilderStore {
  @observable headline: NewTextAsset | null = null;
  @observable postText: NewTextAsset | null = null;
  @observable description: NewTextAsset | null = null;

  @action build = (assetType: CreativeTemplatesEntities) => {
    switch (assetType) {
      case Headlines:
        this.headline = { text: '', postMaloneScore: null };
        break;
      case PostTexts:
        this.postText = { text: '', postMaloneScore: null };
        break;
      case Descriptions:
        this.description = { text: '', postMaloneScore: null };
        break;
    }
  };

  @action changeText = (assetType: CreativeTemplatesEntities, text: string) => {
    switch (assetType) {
      case Headlines:
        if (this.headline) this.headline.text = text;
        break;
      case PostTexts:
        if (this.postText) this.postText.text = text;
        break;
      case Descriptions:
        if (this.description) this.description.text = text;
        break;
    }
  };

  @action changeEngagementScore = (assetType: CreativeTemplatesEntities, engagementScore: number) => {
    switch (assetType) {
      case Headlines:
        if (this.headline)
          this.headline.postMaloneScore = {
            engagementScore: engagementScore,
            sourceType: PostMaloneScoreSourceTypeEnum.manual
          };
        break;
      case PostTexts:
        if (this.postText)
          this.postText.postMaloneScore = {
            engagementScore: engagementScore,
            sourceType: PostMaloneScoreSourceTypeEnum.manual
          };
        break;
      case Descriptions:
        if (this.description)
          this.description.postMaloneScore = {
            engagementScore: engagementScore,
            sourceType: PostMaloneScoreSourceTypeEnum.manual
          };
        break;
    }
  };

  @action remove = (assetType: CreativeTemplatesEntities) => {
    switch (assetType) {
      case Headlines:
        this.headline = null;
        break;
      case PostTexts:
        this.postText = null;
        break;
      case Descriptions:
        this.description = null;
        break;
    }
  };

  @action getTextAsset = (assetType: CreativeTemplatesEntities) => {
    switch (assetType) {
      case Headlines:
        return this.headline;
      case PostTexts:
        return this.postText;
      case Descriptions:
        return this.description;
    }
  };

  @computed get getTextAssets() {
    return [this.postText, this.headline, this.description];
  }
}

export const useTextAssetsBuilderStore = (): TextAssetsBuilderStore => {
  const store = useRootStore();
  if (!store.textAssetsBuilderStore) throw new Error('TA store has not been initialized');
  return store.textAssetsBuilderStore;
};
